import React, { useState, useEffect } from "react";
import axios from "axios";
import BreadcrumbComponent from "./Breadcrumbs";
import { Row, Col, Divider, Skeleton } from "antd";
import PageTitle from "./PageTitle";
import HSCodes from "./HSCodes";
import ContactDetails from "./ContactDetails";
import Stats from "./Stats";
import TradingPartners from "./TradingPartners";
import { useParams } from "react-router-dom";
import OtherTradingPartners from "./OtherTradingPartners";
import HSCodeDistribution from "./HSCodeDistribution";
import Footer from "../Footer";
import API_KEY from "api/recommendations";
import DIRECTUS from "api/index";
export default function BuyerDetails() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [contactData, setContactData] = useState(null);
  const [loadingContactData, setLoadingContactData] = useState(false);
  const { id } = useParams();
  const pref = localStorage.getItem("pref");
  const userHsCode = JSON.parse(pref)?.hs_code;
  const city = JSON.parse(pref)?.city;
  const fetchProspects = () => {
    DIRECTUS.URL.get(DIRECTUS.path.prospects, {
      params: {
        fields: "country,id,name,importer_id",
        "filter[importer_id][_eq]": id,
      },
    })
      .then((res) => {
        const response = res.data.data;
        if (response.length > 0) {
          fetchConstactData();
        }
      })
      .catch((err) => {
        console.log(err);
        setLoadingContactData(false);
      });
  };
  useEffect(() => {
    fetchProspects();
  }, []);
  useEffect(() => {
    setLoading(true);
    axios
      .get(`https://suggest.sourcerer.tech/buyer_data?id=${id}`)
      .then((res) => {
        setLoading(false);
        setData(res.data);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }, [id]);

  var flatArray;
  var mostImportedProduct;
  var hsCodes;
  var tradingPartner;
  if (data?.hscode_distribution) {
    flatArray = Object.assign(...data?.hscode_distribution);
    const max = Math.max.apply(Math, Object.values(flatArray));
    const hsCode = Object.keys(flatArray).find((key) => flatArray[key] === max);
    hsCodes = Object.assign(...data?.hscode_description);
    mostImportedProduct = hsCodes[hsCode];
  }
  if (data?.trading_partners) {
    tradingPartner =
      data?.trading_partners?.find(
        (item) =>
          item?.city?.toLowerCase() === city?.toLowerCase() ||
          item?.city?.toLowerCase().includes(city?.toLowerCase())
      ) || data?.trading_partners?.[0];
  }

  const fetchConstactData = () => {
    setLoadingContactData(true)
    API_KEY.URL.post(
      `${API_KEY.path.contact}?buyer_id=${id}&user_id=${localStorage.getItem(
        "email"
      )}`,
      {}
    )
      .then((res) => {
        setContactData(res.data);
        setLoadingContactData(false);
      })
      .catch((err) => {
        console.log("error", err);
        setLoadingContactData(false);
      });
  };
  const unlock = () => {
    const payload = {
      country: data?.buyer_country,
      importer_id: id,
      name: data?.buyer_name,
      manufacturer: JSON.parse(localStorage.getItem("org"))?.id,
    };
    setLoadingContactData(true);
    DIRECTUS.URL.post(DIRECTUS.path.prospects, payload)
      .then((res) => {
        // setProspectIds((state) => [...state, `${id}`]);
        // fetchProspects();
        fetchConstactData();
      })
      .catch((err) => {
        console.log("err", err);
        setLoadingContactData(false);
      });
  };

  return (
    <Row>
      <Col span={24}>
        <BreadcrumbComponent />
        {loading ? <Skeleton active /> : <PageTitle data={data} />}
        <Divider />
        <Row>
          <Col span={16}>
            {loading ? (
              <Skeleton active />
            ) : (
              <HSCodes data={data} hsCodes={hsCodes} userHsCode={userHsCode} />
            )}
            {loading ? (
              <Skeleton active />
            ) : (
              <Stats
                data={data}
                hscode_distribution={data?.hscode_distribution}
                hscode_description={data?.hscode_description}
                mostImportedProduct={mostImportedProduct}
              />
            )}
            {loading  ? (
              <Skeleton active />
            ) : (
              <TradingPartners
                data={tradingPartner}
                trading_partners={data?.trading_partners}
                overall_trade_value={data?.overall_trade_value}
              />
            )}
            {loading ? (
              <Skeleton active />
            ) : (
              <OtherTradingPartners data={data?.trading_partners} />
            )}
            {loading ? (
              <Skeleton active />
            ) : (
              <HSCodeDistribution
                data={data?.hscode_distribution}
                hsCodes={hsCodes}
                flatArray={flatArray}
              />
            )}
            <Row style={{ marginTop: "3em" }}>
              <Footer />
            </Row>
          </Col>
          <Col span={8}>
            {loading ? null : (
              <ContactDetails
                unlock={unlock}
                contactData={contactData}
                loadingContactData={loadingContactData}
              />
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
